export interface ISubCommittee {
  name: string
  systemCode: string
  url: string
}
